import React, { SVGProps } from 'react';

const IconTrashCan = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 57 76" {...props}>
      <path
        d="M5.075 18.167V67.58c0 1.785 1.181 3.343 2.925 3.72 3.999.862 11.79 2.21 21.456 2.21 9.475 0 16.455-1.295 20.058-2.16 1.667-.399 2.76-1.91 2.76-3.623V18.167"
        stroke="currentColor"
        strokeWidth="3"
      />
      <path
        d="M2.367 11.171a2.5 2.5 0 0 1 2.499-2.5l47.614-.015a2.5 2.5 0 0 1 2.501 2.5l.002 6.233-52.614.016-.002-6.234Z"
        stroke="currentColor"
        strokeWidth="3"
      />
      <path
        d="M21.081 8.545a6.5 6.5 0 0 1 6.498-6.502h2.184a6.5 6.5 0 0 1 6.502 6.498v.095l-15.184.005v-.096ZM20.492 28.473v34.325M37.11 28.473v34.325"
        stroke="currentColor"
        strokeWidth="3"
      />
    </svg>
  );
};

export default IconTrashCan;
